import { render, staticRenderFns } from "./UiConfig.vue?vue&type=template&id=fecd2b14&scoped=true&"
import script from "./UiConfig.vue?vue&type=script&lang=js&"
export * from "./UiConfig.vue?vue&type=script&lang=js&"
import style0 from "./UiConfig.vue?vue&type=style&index=0&id=fecd2b14&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecd2b14",
  null
  
)

export default component.exports